import loadStepStorage from './storage';
import loadStepStorageAdvance from './storage_advance';
import loadStepCommands from './commands';
import loadStepPanels from './panels';

export default (editor, opts = {}) => {
    
    /* Add Step manager */
    loadStepCommands(editor,opts);
    // loadStepStorage(editor, opts);
    loadStepStorageAdvance(editor, opts);
    loadStepPanels(editor,opts);

};